/** Match backend `rbacNaming` prefixes for edit forms (short label in UI, API applies prefix). */

export const ROLE_NAME_PREFIX = 'Role - ';
export const GROUP_NAME_PREFIX = 'Group - ';

export function roleDisplayStem(full) {
  const s = String(full || '').trim();
  return s.startsWith(ROLE_NAME_PREFIX) ? s.slice(ROLE_NAME_PREFIX.length).trim() : s;
}

export function groupDisplayStem(full) {
  const s = String(full || '').trim();
  return s.startsWith(GROUP_NAME_PREFIX) ? s.slice(GROUP_NAME_PREFIX.length).trim() : s;
}
